import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    employees: [],
    totalEmployees: null,
    currentPage: 1,
    perPage: 5,
    employeeTypesCurrentPage: 1,
    employeeTypesPerPage: 5,
    totalEmployeeTypes: null,
    searchQuery: "",
    filterValue: null,
    employeeTypes: [],
    employeeCategories: [],
    employeeCategoriesCurrentPage: 1,
    employeeCategoriesPerPage: 5,
    totalEmployeeCategories: null,
    employeeGrades: [],
    employeeGradesCurrentPage: 1,
    employeeGradesPerPage: 5,
    totalEmployeeGrades: null,
    employeeBranches: [],
    employeeDepartments: [],
    employeeDesignations: [],
    employeeDesignationsCurrentPage: 1,
    employeeDesignationsPerPage: 5,
    totalEmployeeDesignations: null,
    showUploadDialog: false,
    archivedEmployees: [],
    totalArchivedEmployees: null,
    archiveEmployeeCurrentPage: 1,
    archiveEmployeePerPage: 5,
  },
  actions,
  mutations,
};
